import echarts from 'echarts'
const install = function (Vue) {
  Object.defineProperties(Vue.prototype, {
    $chart: {
      get () {
        return {
          line1: function (id) {
            require('echarts/src/chart/pie')
            require('echarts/lib/component/tooltip')
            require('echarts/lib/component/title')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              title: {
                text: '',
                x: 'center',
                bottom: 10
              },
              series: [
                {
                  name: 'Report1',
                  type: 'pie',
                  radius: '50%',
                  data: [
                    {value: 120, name: '19%', itemStyle: {color: '#F5CC60'}},
                    {value: 400, name: '40% Very Satiafied', itemStyle: {color: '#FF925D'}},
                    {value: 120, name: '19%', itemStyle: {color: '#8ECEFE'}},
                    {value: 120, name: '21%', itemStyle: {color: '#DACEFF'}},
                    {value: 120, name: '19%', itemStyle: {color: '#F47C7D'}}
                  ],
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            }
            this.chart.setOption(optionData)
          },
          line2: function (id) {
            require('echarts/src/chart/line')
            require('echarts/lib/component/tooltip')
            require('echarts/lib/component/title')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              title: {
                text: ''
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross',
                  label: {
                    backgroundColor: '#6a7985'
                  }
                }
              },
              // toolbox: {
              //   feature: {
              //     saveAsImage: {}
              //   }
              // },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  boundaryGap: false,
                  data: ['类别1', '类别2', '类别3', '类别4', '类别5', '类别6', '类别7', '类别8']
                }
              ],
              yAxis: [
                {
                  type: 'value'
                }
              ],
              series: [
                {
                  name: '邮件营销',
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  data: [220, 182, 191, 1500, 290, 330, 310, 1000]
                },
                {
                  name: '联盟广告',
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  data: [220, 182, 191, 234, 290, 330, 310, 800]
                }
              ]
            }
            this.chart.setOption(optionData)
          },
          line3: function (id, register, unregister) {
            require('echarts/src/chart/pie')
            require('echarts/lib/component/tooltip')
            require('echarts/lib/component/title')
            require('echarts/lib/component/legend')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              tooltip: {
                trigger: 'item',
                formatter: '{b}{c}人\n{d}%'
              },
              legend: {
                bottom: 10,
                left: 'center',
                data: ['已关注', '未关注'],
                selectedMode: false
              },
              series: [
                {
                  name: 'Report1',
                  type: 'pie',
                  radius: '50%',
                  center: ['50%', '50%'],
                  label: {
                    normal: {
                      show: true,
                      formatter: '{c}人\n{d}%'
                    }
                  },
                  data: [
                    {value: register, name: '已关注', itemStyle: {color: '#4BC1EB'}},
                    {value: unregister, name: '未关注', itemStyle: {color: '#FFE97B'}}
                  ],
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            }
            this.chart.setOption(optionData)
          },
          line4: function (id, xAxis, yAxis) {
            require('echarts/lib/chart/bar')
            require('echarts/lib/component/tooltip')
            require('echarts/lib/component/title')
            require('echarts/lib/component/legend')
            require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const colorJb = new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#FDA366'
            }, {
              offset: 1,
              color: '#FF925D'
            }])
            const optionData = {
              title: {
                text: '各APP的内容发布总数',
                subtext: '文章数'
              },
              tooltip: {},
              grid: {
                width: 'calc(100% - 80px)',
                left: '40px'
              },
              xAxis: {
                data: xAxis,
                axisLabel: {
                  textStyle: {
                    fontSize: 6
                  }
                }
              },
              yAxis: [
                {
                  splitNumber: 7
                }
              ],
              series: [{
                name: '文章数',
                type: 'bar',
                barWidth: '50%',
                data: yAxis,
                itemStyle: {
                  normal: {
                    color: function (params) {
                      return colorJb
                    },
                    label: {
                      show: true,
                      position: 'top',
                      textStyle: {
                        color: 'black',
                        fontSize: 12
                      }
                    }
                  }
                }
              }]
            }
            this.chart.setOption(optionData)
          },
          line5: function (id, xAxis, yAxis, type, color, myData) {
            require('echarts/lib/chart/bar')
            require('echarts/lib/component/tooltip')
            require('echarts/lib/component/title')
            require('echarts/lib/component/legend')
            require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const colorJb = new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: color.split(',')[1]
            }, {
              offset: 1,
              color: color.split(',')[0]
            }])
            const optionData = {
              title: {
                subtext: type
              },
              tooltip: {
                trigger: 'axis',
                backgroundColor: '#fff',
                borderColor: '#333',
                borderWidth: 1,
                textStyle: {
                  color: '#333'
                },
                formatter (v) {
                  return 'APP: ' + myData[v[0].dataIndex].appName + '<br>内容类别: ' + myData[v[0].dataIndex].contentTypeName + '<br>文章名称: ' + myData[v[0].dataIndex].contentTitle
                }
              },
              grid: {
                width: 'calc(100% - 80px)',
                left: '40px',
                bottom: '30%'
              },
              xAxis: {
                data: xAxis,
                axisLabel: {
                  rotate: 45,
                  formatter (v) {
                    let text = v
                    if (text.length <= 20) {
                      return text
                    } else {
                      return `${text.slice(0, 20)}...`
                    }
                    // if (text.length <= 12) {
                    //   return text
                    // } else if (text.length > 12 && text.length <= 22) {
                    //   return `${text.slice(0, 12)}\n${text.slice(12)}`
                    // } else if (text.length > 22 && text.length <= 32) {
                    //   return `${text.slice(0, 12)}\n${text.slice(12, 22)}\n${text.slice(22)}`
                    // } else if (text.length > 32 && text.length <= 42) {
                    //   return `${text.slice(0, 12)}\n${text.slice(12, 22)}\n${text.slice(22, 32)}\n${text.slice(32)}`
                    // } else if (text.length > 42) {
                    //   return `${text.slice(0, 12)}\n${text.slice(12, 22)}\n${text.slice(22, 32)}\n${text.slice(32, 42)}\n${text.slice(42)}`
                    // }
                  },
                  textStyle: {
                    color: '#666',
                    fontSize: 10
                  }
                }
              },
              yAxis: [
                {
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: '#999'
                    }
                  }
                }
              ],
              series: [{
                name: type,
                type: 'bar',
                barWidth: '50%',
                data: yAxis,
                itemStyle: {
                  normal: {
                    color: function (params) {
                      return colorJb
                    },
                    label: {
                      show: true,
                      position: 'top',
                      textStyle: {
                        color: color.split(',')[0],
                        fontSize: 12
                      }
                    }
                  }
                }
              }]
            }
            this.chart.setOption(optionData)
          }
        }
      }
    }
  })
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/assets/js/myCharts.js